angular.module('bribac.views.editRuleSet', [
  'ngRoute',
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.updateRuleSetEditFormat',
  'bribac.components.whenLoaded',
  'bribac.components.ruleSetEditor'
])

  .config(function(
    $routeProvider
  ) {
    var config =  {
      templateUrl: 'edit-rule-set-view.html',
      controller: 'EditRuleSetViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: /*@ngInject*/ function(routeAuth) {return routeAuth.requireAuth()}}
    }

    $routeProvider.when('/settings/:id/edit', config)
    $routeProvider.when('/templates/settings/:id/edit', config)
  })

  .controller('EditRuleSetViewCtrl', function(
    $routeParams,
    $location,
    KINDS,
    api,
    state,
    updateRuleSetEditFormat
  ) {

    var $ctrl = this

    var id = parseInt($routeParams.id)

    if (!isFinite(id)) {
      // TODO: Should show 404 error instead. Should probably do this check in the $routeProvider config.
      return
    }

    $ctrl.successCallback = function() {
      $location.url($location.path().replace(/\/edit$/, ''))
    }

    // Init

    $ctrl.ruleSetPromise = api.get(KINDS.RULE_SET, id).then(function(request) {
      $ctrl.ruleSet = request.data
      $ctrl.editableRuleSet = updateRuleSetEditFormat(angular.copy($ctrl.ruleSet))
    })

  })
